<template>
  <label class="legend">{{ title }}<span v-if="required" class="uk-text-danger">*</span></label>
</template>
<style lang="scss" scoped>
label.legend {
  color: $brand-color;
  font-weight: bold;
}
</style>
<script lang="ts">
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
export default class FieldLabel extends Vue {
  @Prop({ type: String, required: true }) title = "";
  @Prop({ type: Boolean }) required = false;
}
</script>
